import { Link } from "react-router-dom";

const featuredResources = [
  {
    title: "BaseTao Review 2026",
    description: "Honest and comprehensive review covering user experience, pros and cons, and overall value assessment.",
    icon: "ri-star-line",
    link: "/article/basetao-review",
    imageUrl: "https://readdy.ai/api/search-image?query=Person%20thoughtfully%20reviewing%20fashion%20products%20on%20a%20laptop%20at%20a%20cozy%20cafe%2C%20warm%20natural%20lighting%2C%20cream%20interior%2C%20modern%20lifestyle%20scene%2C%20authentic%20decision%20making%20moment%2C%20editorial%20photography%2C%20high%20detail%2C%20soft%20warm%20tones%2C%20relaxed%20genuine%20atmosphere&width=600&height=400&seq=feat-review-v3&orientation=landscape",
  },
  {
    title: "Shipping Cost Guide",
    description: "Detailed breakdown of shipping costs by country, shipping line, and package weight with real price estimates.",
    icon: "ri-ship-line",
    link: "/article/basetao-shipping-cost",
    imageUrl: "https://readdy.ai/api/search-image?query=Neatly%20arranged%20international%20shipping%20packages%20with%20colorful%20customs%20labels%20on%20a%20bright%20clean%20surface%2C%20natural%20daylight%2C%20organized%20logistics%20aesthetic%2C%20warm%20minimalist%20setting%2C%20professional%20ecommerce%20photography%2C%20high%20detail%2C%20cream%20and%20beige%20tones&width=600&height=400&seq=feat-shipping-v3&orientation=landscape",
  },
  {
    title: "Warehouse Guide",
    description: "Everything about BaseTao warehouse services including storage, QC photos, inspection, and packaging.",
    icon: "ri-store-2-line",
    link: "/article/basetao-warehouse",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20organized%20small%20warehouse%20with%20product%20shelves%20and%20inspection%20table%2C%20warm%20overhead%20lighting%2C%20modern%20organized%20storage%2C%20professional%20quality%20control%20environment%2C%20bright%20airy%20atmosphere%2C%20high%20detail%2C%20cream%20and%20soft%20industrial%20tones&width=600&height=400&seq=feat-warehouse-v3&orientation=landscape",
  },
  {
    title: "Coupon & Discount Guide",
    description: "Updated coupon codes, discount methods, and money-saving strategies for smarter purchases.",
    icon: "ri-coupon-line",
    link: "/article/basetao-coupon",
    imageUrl: "https://readdy.ai/api/search-image?query=Colorful%20shopping%20discount%20tags%20and%20gift%20vouchers%20arranged%20beautifully%20on%20a%20cream%20linen%20background%2C%20soft%20natural%20light%2C%20elegant%20commercial%20aesthetic%2C%20playful%20sophisticated%20composition%2C%20editorial%20product%20photography%2C%20high%20detail%2C%20warm%20inviting%20tones&width=600&height=400&seq=feat-coupon-v3&orientation=landscape",
  },
  {
    title: "Is BaseTao Legit?",
    description: "Security analysis covering payment protection, privacy, user verification, and risk assessment.",
    icon: "ri-shield-check-line",
    link: "/article/is-basetao-legit",
    imageUrl: "https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20trust%20symbols%20displayed%20elegantly%20on%20a%20modern%20laptop%2C%20warm%20reassuring%20lighting%2C%20professional%20clean%20home%20office%20setting%2C%20calm%20confident%20atmosphere%2C%20editorial%20technology%20photography%2C%20high%20detail%2C%20cream%20and%20soft%20green%20tones&width=600&height=400&seq=feat-legit-v3&orientation=landscape",
  },
];

export default function FeaturedResources() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100/80 text-accent-700 text-xs font-medium rounded-full mb-4">
            Featured Resources
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Explore Our BaseTao Spreadsheet Resources
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Comprehensive guides and tools to help you master every aspect of BaseTao shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredResources.map((resource) => (
            <Link
              key={resource.title}
              to={resource.link}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div
                className="w-full aspect-[3/2] bg-cover bg-center"
                style={{
                  backgroundImage: `url('${resource.imageUrl}')`,
                }}
              ></div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                    <i className={`${resource.icon} text-sm text-primary-600`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900">
                    {resource.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {resource.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  Read More
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}